import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faStar } from '@fortawesome/pro-duotone-svg-icons';
import { faLocationDot, faUserDoctor } from '@fortawesome/pro-regular-svg-icons';
import { sxModal, sxSemibold, sxRegular, sxBold, sxRegularLight } from './sxProps';
import './styles.css'
import { Divider, Typography } from '@mui/material';
import { ContatoModalProps } from '../../../interfaces/props/SaudeOnline/LinhaTempo/ContatoModalProps';
import { useEffect, useState } from 'react';
import { capitalize } from "../../../utils/Capitalize"
import { Doctor } from '../../../interfaces/entities/Doctor';
import { cadastroFavorito, removeFavorito } from '../../../services/SaudeOnlineService';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import ButtonAccessibility from '../../../components/Accessibility/ButtonAccessibility';

function ContatoModal(props: ContatoModalProps) {

  const [nome, setNome] = useState<string>('');
  const [especialidade, setEspecialidade] = useState<string>('');
  const [contatos, setContatos] = useState<Doctor[]>([]);

  const accessibility = useAccessibility();


  useEffect(() => {
    if (props.contatos && props.contatos.length) {
      setNome(props.contatos[0].nomePessoa);
      setEspecialidade(capitalize(props.contatos[0].descrEspec));
      setContatos(props.contatos);
    }
  }, [props.contatos]);

  const handleCloseModal = () => {
    props.handleCloseModal();
  }

  const toggleFavorito = (doctor: Doctor) => {
    (doctor.isFavorito ? removeFavorito : cadastroFavorito)(doctor.id);
    const newContatos = contatos.map(d => d.id === doctor.id
      ? { ...d, isFavorito: !doctor.isFavorito }
      : d
    )
    setContatos(newContatos);
  }

  const openGoogleMapsWithAddress = (data: any) => {
    const {
      logradouro,
      numero,
      complemento,
      bairro,
      cidade,
      uf,
      cep,
    } = data;

    const fullAddress = `${logradouro}, ${numero}, ${bairro}, ${cidade} - ${uf}`;

    window.open(`http://maps.google.com/?q=${fullAddress}`, "_blank")
  };

  return (
    <div>
      <Modal
        open={props.open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={sxModal} style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
          <div className="confirmation-feedback-modal-header">
            <Typography style={accessibility.textStyleAccessibility} sx={sxBold}>Informações de contato</Typography>
            <button aria-label="fechar informações do contato" className='confirmation-modal-header-close' onClick={handleCloseModal}><FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faTimes} /></button>
          </div>

          <div className="modal-content-holder">
            <div className="contato-holder">
              <div className="contato-row-holder">
                <FontAwesomeIcon icon={faUserDoctor} style={accessibility.textStyleAccessibility} className="icon-doctor" />
                <div className="contato-info-holder">
                  <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSemibold }}>{nome}</Typography>
                  <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxRegular }}>{especialidade}</Typography>
                </div>
              </div>

              <Divider style={{ width: '100%', marginTop: '10px', marginBottom: '30px' }} />
              <ul>
              {
                !!contatos && contatos.map(contato =>
                  <li className="contato-item-holder" key={contato.id}>
                    <div className="contato-row-holder">
                      <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faLocationDot} className="icon-address" />
                      <div className="contato-info-holder">
                        <Typography style={accessibility.textStyleAccessibility} sx={sxRegularLight}>{contato.descrEspec}</Typography>
                        <Typography style={accessibility.textStyleAccessibility} sx={sxRegularLight}>{`${contato.logradouro} ${contato.numero}`}</Typography>
                        <Typography style={accessibility.textStyleAccessibility} sx={sxRegularLight}>{contato.complemento}</Typography>
                        <Typography style={accessibility.textStyleAccessibility} sx={sxRegularLight}>{`${contato.bairro} - ${contato.cidade} - ${contato.uf}`}</Typography>
                        <Typography style={accessibility.textStyleAccessibility} sx={sxRegularLight}>{contato.telefone}</Typography>

                        <div className='contato-info-button'>
                          <ButtonAccessibility
                            variant='contained'
                            onClick={() => openGoogleMapsWithAddress(contato)}>
                            Ver no mapa
                          </ButtonAccessibility>
                        </div>
                        
                        <div className='contato-info-data'>
                          <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxRegularLight, color: '#5F5F5F' }}>Provável disponibilidade:</Typography>
                          <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxRegularLight, color: '#5F5F5F' }}>{contato.dtDispon ? contato.dtDispon : '-'}</Typography>
                        </div>

                      </div>
                    </div>
                    <button style={{background: 'none', border: 'none', height: 'fit-content'}}   
                      onClick={() => { toggleFavorito(contato) }} 
                      onKeyDown={key => { if (key.code === 'Enter') toggleFavorito(contato); }}
                      aria-label={`favoritar ${contato.nomePessoa}`}
                    >
                      <FontAwesomeIcon
                        icon={faStar}
                        className={`star-icon ${contato.isFavorito && 'star-icon-selected'}`}
                        title={contato.isFavorito ? 'Remover favorito' : 'Favoritar'}      
                      />
                    </button>
                    

                  </li>
                )}
              </ul>
            </div>

          </div>

        </Box>
      </Modal>
    </div>
  );
}

export default ContatoModal;